import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import RightSideDetailsPanel from "./rightSideDetailsPanel";
import graphActionCreator from "../../Documents/graph/redux/actionCreators";
const mapDispatchToProps = (dispatch) => ({
    onSetPanelWidth: (width) => dispatch(actionCreators.setPanelWidth(width)),
    onOpenGroupTableViewModal: (documentId, data) => {
        dispatch(graphActionCreator.setTableModalState(true));
        dispatch(graphActionCreator.setGroupTableData(documentId, data));
    }
});
export default connect(undefined, mapDispatchToProps)(RightSideDetailsPanel);
